import React, { useEffect, useState } from "react";
import { ProfileService } from "../../../../services/ProfileService";
import SvgPeerRating from "../../../../components/svg/svgpeerrating"
import SvgSkillCount from "../../../../components/svg/svgskillcount"
import { Stringutility } from "../../../../utilities/stringutility";
import { StorageService } from "../../../../services/StorageService";
import { StorageValues } from "../../../../constants/storageValues";
import { Link } from "react-router-dom";

const DashboardPeerRating = () => {
  const [skillCount, setSkillCount] = useState();
  const [ratingCount, setRatingCount] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  useEffect(() => {
   let firstName=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.NAME));
   let lastName=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.LASTNAME));
   setFirstName(firstName);
   setLastName(lastName);
    getPeerRating();
    getCandidateSkillList();
  }, []);

  const getCandidateSkillList = () => {
    ProfileService.getProfileSkills().then((response) => {
      try {
        if (response.data != null) {
          setSkillCount(response.data.size);
        }
      } catch (err) {
        console.error("getProfileSkills" + JSON.stringify(err));
      }
    });
  };

  const getPeerRating = () => {
    ProfileService.getRating().then((response) => {
      try {
        var peerRatinhDetails = response.data;
        if (peerRatinhDetails != null) {
          setRatingCount(response.data.size);
        }
      } catch (err) {
        console.error("getRating" + JSON.stringify(err));
      }
    });
  };

  return (
    <>
      <>
        <div
          className="welcomeContainer 
                        order-1 
                        max-lg:col-span-1 min-lg:col-span-3 min-xl:col-span-3 min-2xl:col-span-2 "
        >
          <div
            className="welcomeWrapper relative grid max-md:gap-4 min-md:gap-7 
                            max-md:grid-cols-6 min-md:grid-cols-6 
                            bg-primary-white min-md:rounded-3xl min-md:shadow-lg 
                            max-md:px-4 min-md:px-7 max-md:pb-7 max-md:pt-7 pb-4"
          >
            <div className="welcomeBG absolute max-md:-left-4 top-2 left-2 z-10">
              <svg
                width="128"
                height="96"
                viewBox="0 0 88 69"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.3"
                  d="M35.7846 68.9625C55.5479 68.9625 71.5692 53.5247 71.5692 34.4812C71.5692 15.4378 55.5479 0 35.7846 0C16.0213 0 0 15.4378 0 34.4812C0 53.5247 16.0213 68.9625 35.7846 68.9625Z"
                  fill="#CDE7FE"
                />
                <path
                  d="M87.6576 14.2773C88.3748 11.1406 86.4135 8.01641 83.2768 7.29917C80.1401 6.58193 77.0159 8.54327 76.2987 11.6799C75.5814 14.8166 77.5428 17.9408 80.6794 18.6581C83.8161 19.3753 86.9403 17.414 87.6576 14.2773Z"
                  fill="#81C9FF"
                />
              </svg>
            </div>

            <div
              className="welcomeTitle 
                                order-1 max-md:row-span-2 max-md:col-span-3 min-md:col-span-4 
                                z-20"
            >
              <div className="max-md:text-2xl min-md:text-3xl font-bold text-primary-dark mt-7 pb-1">
                Welcome,{" "}
                <span className="min-md:hidden">
                  <br />
                </span>
                <span>{firstName + " " + lastName}</span>
              </div>
              <div className="text-base text-primary-dark">
                {/* A peer network to grow your career */}
                Peer ratings of skills confirm strengths and lead to quicker decisions. Ask colleagues to rate your skills. The more skill ratings, the better!
              </div>
            </div>

            <div
              className="welcomeGraphic 
                                order-2 
                                max-md:col-span-2 min-md:col-span-2
                                max-md:row-span-1 min-xl:row-span-2"
            >
              <span className="">
              
                <SvgPeerRating/>
              </span>
            </div>

            <div
              className="skillsContainer 
                                order-3
                                max-md:col-span-6 min-md:col-span-6 min-xl:col-span-3 
                                grid gap-4 max-md:grid-cols-2 min-md:grid-cols-6"
            >
              <div
                className="skills 
                                    bg-primary-blue text-primary-white rounded-xl px-6 py-3 
                                    max-md:col-span-1 min-md:col-span-3 
                                    shadow-md hover:shadow-sm transition-all ease-in-out duration-300"
              >
                <div className="">
                  <div className="max-md:text-sm font-semibold">Skills</div>
                  <div className="flex flex-row flex-nowrap relative gap-1">
                    <div className="skillsCount col-start-1 row-start-2 max-md:text-3xl text-4xl font-semibold tracking-wide justify-self-center">
                      {" "}
                      {skillCount}
                    </div>
                    <svg
                      width="28"
                      height="28"
                      className="skillsGraph col-start-2 row-start-2 self-center max-md:max-w-[24px] max-md:max-h-[24px] "
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 19H13M7 19V14M7 19H1.6C1.26863 19 1 18.7314 1 18.4V14.6C1 14.2686 1.26863 14 1.6 14H7M13 19V7M13 19H18.4C18.7314 19 19 18.7314 19 18.4V1.6C19 1.26863 18.7314 1 18.4 1H13.6C13.2686 1 13 1.26863 13 1.6V7M13 7H7.6C7.26863 7 7 7.26863 7 7.6V14"
                        stroke="white"
                      />
                    </svg>

                    <Link
                     to={"/myProfile/candidateSkills"}  href="/myProfile"
                      className="absolute right-0 bottom-1 justify-items-center inline-grid"
                    >
                     
                      <SvgSkillCount/>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="peers 
                                    bg-primary-blue text-primary-white rounded-xl px-6 py-3  
                                    max-md:col-span-1 min-md:col-span-3 
                                    shadow-md hover:shadow-sm transition-all ease-in-out duration-300"
              >
                <div className="">
                  <div className="max-md:text-sm font-semibold">My Peers</div>
                  <div className="flex flex-row flex-nowrap relative gap-1">
                    <div className="peersCount col-start-1 row-start-2 max-md:text-3xl text-4xl font-semibold tracking-wide justify-self-center">
                      {ratingCount}{" "}
                    </div>
                    <svg
                      width="36"
                      height="36"
                      className="peersStars col-start-2 row-start-2 self-center max-md:max-w-[24px] max-md:max-h-[24px] "
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.63495 14.4151L5.67396 12.2121C5.80734 11.9293 6.19266 11.9293 6.32604 12.2121L7.36505 14.4151L9.68859 14.7706C9.98671 14.8162 10.1055 15.1997 9.8897 15.4198L8.2087 17.1334L8.60542 19.5543C8.65637 19.8652 8.34456 20.1022 8.07781 19.9554L6 18.8118L3.92219 19.9554C3.65544 20.1022 3.34363 19.8652 3.39458 19.5543L3.7913 17.1334L2.1103 15.4198C1.89447 15.1997 2.01329 14.8162 2.31141 14.7706L4.63495 14.4151Z"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.6349 14.4151L17.674 12.2121C17.8073 11.9293 18.1927 11.9293 18.326 12.2121L19.3651 14.4151L21.6886 14.7706C21.9867 14.8162 22.1055 15.1997 21.8897 15.4198L20.2087 17.1334L20.6054 19.5543C20.6564 19.8652 20.3446 20.1022 20.0778 19.9554L18 18.8118L15.9222 19.9554C15.6554 20.1022 15.3436 19.8652 15.3946 19.5543L15.7913 17.1334L14.1103 15.4198C13.8945 15.1997 14.0133 14.8162 14.3114 14.7706L16.6349 14.4151Z"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.6349 5.41515L11.674 3.21211C11.8073 2.9293 12.1927 2.9293 12.326 3.21211L13.3651 5.41515L15.6886 5.7706C15.9867 5.8162 16.1055 6.19974 15.8897 6.41976L14.2087 8.13337L14.6054 10.5543C14.6564 10.8652 14.3446 11.1022 14.0778 10.9554L12 9.81178L9.92219 10.9554C9.65544 11.1022 9.34363 10.8652 9.39458 10.5543L9.7913 8.13337L8.1103 6.41976C7.89447 6.19974 8.01329 5.8162 8.31141 5.7706L10.6349 5.41515Z"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <a
                      href="/peerrating"
                      className="absolute right-0 bottom-1 justify-items-center inline-grid"
                    >
                      <SvgSkillCount/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default DashboardPeerRating;